<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-fund`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 5a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 001 1h30a1 1 0 001-1V5zm5 7a2 2 0 00-2-2H5a2 2 0 00-2 2v29a2 2 0 002 2h38a2 2 0 002-2V12zM7 14h34v25H7V14zm14.027 2.21l.094.083 2.914 2.913 2.915-2.913a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-3.465 3.464H30a1 1 0 011 1v2a1 1 0 01-1 1h-4v2h4a1 1 0 011 1v2a1 1 0 01-1 1h-4v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4v-2h-4a1 1 0 01-1-1v-2a1 1 0 011-1h3.756l-3.463-3.464a1 1 0 01-.083-1.32l.083-.094 1.414-1.414a1 1 0 011.32-.083z"/></svg>
</template>
<script>

export default {
  name: 'IconFund',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
